import { LoyaltyDomainSpecificErrorCode, NotificationType } from '@vista/omnichannel-components-domain';
import { getIdForComponentNotification } from '../../../../../utils/get-id-for-component-notification';
const getNotificationId = (componentName, context) => {
    return getIdForComponentNotification(componentName, NotificationType.Error, context);
};
export const getNotificationDetailsForPasswordApiError = (componentName, displayText, error) => {
    switch (error.errorCode) {
        case LoyaltyDomainSpecificErrorCode.PasswordContainsEmail:
            return {
                id: getNotificationId(componentName, 'password-contains-email'),
                messages: [displayText.passwordContainsEmailErrorMessage]
            };
        case LoyaltyDomainSpecificErrorCode.PasswordContainsGivenOrSurname:
            return {
                id: getNotificationId(componentName, 'password-contains-name'),
                messages: [displayText.passwordContainsGivenOrSurnameErrorMessage]
            };
        case LoyaltyDomainSpecificErrorCode.PasswordContainsUsername:
            return {
                id: getNotificationId(componentName, 'password-contains-username'),
                messages: [displayText.passwordContainsUsernameErrorMessage]
            };
        case LoyaltyDomainSpecificErrorCode.PasswordContainsDisallowedWords:
            return {
                id: getNotificationId(componentName, 'password-contains-disallowed-words'),
                messages: [displayText.passwordContainsDisallowedWordsErrorMessage]
            };
        case LoyaltyDomainSpecificErrorCode.PasswordMaximumLengthExceeded:
            return {
                id: getNotificationId(componentName, 'password-maximum-length-exceeded'),
                messages: [displayText.passwordMaximumLengthExceededErrorMessage]
            };
        case LoyaltyDomainSpecificErrorCode.PasswordMinimumNumericCharactersNotMet:
            return {
                id: getNotificationId(componentName, 'password-minimum-numeric-characters-not-met'),
                messages: [displayText.passwordMinimumNumericCharactersNotMetErrorMessage]
            };
        case LoyaltyDomainSpecificErrorCode.PasswordMinimumDistinctCharactersNotMet:
            return {
                id: getNotificationId(componentName, 'password-minimum-distinct-character-not-met'),
                messages: [displayText.passwordMinimumDistinctCharactersNotMetErrorMessage]
            };
        case LoyaltyDomainSpecificErrorCode.PasswordMinimumLengthNotMet:
            return {
                id: getNotificationId(componentName, 'password-minimum-length-not-met'),
                messages: [displayText.passwordMinimumLengthNotMetErrorMessage]
            };
        case LoyaltyDomainSpecificErrorCode.PasswordMinimumNonNumericCharactersNotMet:
            return {
                id: getNotificationId(componentName, 'password-minimum-non-numeric-characters-not-met'),
                messages: [displayText.passwordMinimumNonNumericCharacterNotMetErrorMessage]
            };
        case LoyaltyDomainSpecificErrorCode.PasswordKnownCompromised:
            return {
                id: getNotificationId(componentName, 'password-known-compromised'),
                messages: [displayText.passwordKnownCompromisedErrorMessage]
            };
        default:
            // Note: not providing a default to allow callers to extend mapping for other types of errors.
            return;
    }
};
